// 用常量代替事件类型，使得代码更清晰
export const ADD_TOKEN = 'ADD_TOKEN'
export const ADD_USERID = 'ADD_USERID'
export const REMOVE_COUNT = 'REMOVE_COUNT'
